import { ApolloError, useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import React from 'react';
import wpImageUrl from '../wp-image-url';

const ADS_QUERY = gql`
  query Ads {
    ads(where: { status: PUBLISH }) {
      nodes {
        id
        featuredImage {
          node {
            mediaItemUrl
          }
        }
        title
        adACF {
          url
        }
        content
        adTypes {
          nodes {
            name
          }
        }
      }
    }
  }
`;

interface IAd {
  id: string;
  title: string;
  url: string;
  content: string;
  category: string;
  featuredImage: string;
}

export const AdsContext = React.createContext<{
  ads: Array<IAd>;
  loading: boolean;
  error?: ApolloError;
}>({ ads: [], loading: true });

function mapAds(ad): IAd {
  return {
    id: ad.id,
    title: ad.title,
    content: ad.content,
    category: ad.adTypes.nodes[0]?.name || '',
    url: ad.adACF.url,
    featuredImage: wpImageUrl(ad?.featuredImage?.node?.mediaItemUrl || ''),
  };
}

export function getAd(
  ads: Array<IAd>,
  options: { category?: string; count?: number } = {}
): Array<IAd> | undefined {
  const { category, count = 1 } = options;
  const filteredAds = category
    ? ads.filter((i) => i.category === category)
    : ads;
  return filteredAds.slice(0, count);
}

export const AdsProvider: React.FC = ({ children }) => {
  const { loading, error, data } = useQuery(ADS_QUERY);

  const ads: Array<IAd> = data ? data.ads.nodes.map(mapAds) : [];

  return (
    <AdsContext.Provider value={{ ads, loading, error }}>
      {children}
    </AdsContext.Provider>
  );
};
